const EGDSIconLoyaltyThemes = {
    LOW: 'lowtier',
    MID: 'midtier',
    HIGH: 'hightier',
    EXTRAHIGH: 'extrahightier',
    VIP: 'vip',
};

export { EGDSIconLoyaltyThemes };
//# sourceMappingURL=index.esm.js.map
